/*=========================================================================================
  File Name: moduleUserMutations.js
  Description: User Module Mutations
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {
  SET_USERS (state, users) {
    state.users = users
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
  UPDATE_USER(state, payload){
    const index = state.users.findIndex(user => user.id == payload.id);
    state.users.splice(index, 1)
    state.users.splice(index, 0, payload)
  }
}